import {
  AgileExpertIcon,
  ArchitectIcon,
  DataAIEngineerIcon,
  DevOpsPlatformEngineerIcon,
  EmbeddedIntegrationEngineerIcon,
  interestedIcon,
  LeadershipManagementIcon,
  notInterestedIcon,
  OtherIcon,
  ProductProjectManagerIcon,
  QAEngineerIcon,
  SecurityComplianceEngineerIcon,
  SoftwareEngineerIcon,
  UXDesignerResearcherIcon,
} from './assets/Icons';

export const roles = [
  {
    name: 'Agile Expert',
    Icon: AgileExpertIcon,
  },
  {
    name: 'Architect',
    Icon: ArchitectIcon,
  },
  {
    name: 'Data & AI Engineer',
    Icon: DataAIEngineerIcon,
  },
  {
    name: 'DevOps / Platform Engineer',
    Icon: DevOpsPlatformEngineerIcon,
  },
  {
    name: 'Embedded / Integration Engineer',
    Icon: EmbeddedIntegrationEngineerIcon,
  },
  {
    name: 'Leadership & Management',
    Icon: LeadershipManagementIcon,
  },
  {
    name: 'Product / Project Manager',
    Icon: ProductProjectManagerIcon,
  },
  {
    name: 'QA Engineer',
    Icon: QAEngineerIcon,
  },
  {
    name: 'Security & Compliance Engineer',
    Icon: SecurityComplianceEngineerIcon,
  },
  {
    name: 'Software Engineer',
    Icon: SoftwareEngineerIcon,
  },
  {
    name: 'UX Designer & Researcher',
    Icon: UXDesignerResearcherIcon,
  },
  {
    name: 'Other',
    Icon: OtherIcon,
  },
];

export const researchPanelInterestOptions = [
  {
    name: 'Interested',
    value: true,
    Icon: interestedIcon,
  },
  {
    name: 'Not Interested',
    value: false,
    Icon: notInterestedIcon,
  },
];
